import React, { useState, useEffect } from "react";
import axios from "axios";
import Pagination from "../Pagination";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ViewUserModalProfile from "../admin/ViewUserModalProfile";
import UpdateUserModalProfile from "../admin/UpdateUserModalProfile";
import CustomAlert from "../CustomAlert";

function RequestedCallListing() {
  const [loading, setLoading] = useState(true);
  const [FormList, getVideoChatFormData] = useState([]);
  const userId = localStorage.getItem("userId");
  const [totalPages, setTotalPages] = useState(null);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const API_URL = `${process.env.REACT_APP_API_URL}/svconsultation/list?user_id=${userId}&type=singlevacationconsulatant`;
  const TOKEN = localStorage.getItem("adminToken");

  const [showPopup, setShowPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedName, setSelectedName] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // States for View and Edit modals
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedLadyId, setSelectedLadyId] = useState(null);

  const fetchVideoChatFormData = () => {
    setLoading(true);
    fetch(API_URL, {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        getpaginatedData(currentPage);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
        toast.error("Failed to fetch call data.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    console.log("RequestedCallListing mounted, fetching data...");
    fetchVideoChatFormData();
  }, []);

  const delUserdata = (id) => {
    if (window.confirm("Do you want to delete this call?")) {
      axios
        .delete(`${process.env.REACT_APP_API_URL}/svconsultation/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
          },
        })
        .then(() => {
          toast.success("Call deleted successfully!");
          fetchVideoChatFormData();
        })
        .catch((error) => {
          console.error("Error deleting user data:", error);
          toast.error("Failed to delete call.");
        });
    }
  };

  const togglePopup = (id, name) => {
    console.log("Toggling popup:", { id, name, showPopup });
    setSelectedId(id);
    setSelectedName(name);
    setShowPopup(!showPopup);
  };

  const main_from_inner_wrap_style = {
    padding: "0px !important",
  };

  const handlePaginationClick = (newPage) => {
    setCurrentPage(newPage);
    getpaginatedData(newPage);
  };

  const getpaginatedData = async (newPage) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/zoom/getMeetings/?translaterId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      const responseData = res.data;
      getVideoChatFormData(responseData);
      setTotalItems(responseData.length);
      setTotalPages(Math.ceil(responseData.length / itemsPerPage));
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch meeting data.");
    }
  };

  const [ladieslisting, setLadiesListingData] = useState([]);

  const handleAssignladySubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const cahtId = formData.get("caht_id");
    const profilenumber_ladies = formData.get("lady_id");
    const meeting_id = formData.get("meeting_id");

    if (profilenumber_ladies) {
      setError("");
      const data = new URLSearchParams();
      data.append("ladiesId", "#FCW_" + profilenumber_ladies);

      try {
        setLoading(true);
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/zoom/updateMeetingstatus/${meeting_id}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${TOKEN}`,
            },
          }
        );
        setSuccessMessage("New Lady assigned successfully");
        fetchVideoChatFormData();
        setShowPopup(false);
      } catch (error) {
        console.error("Assign lady error:", error);
        setError("Failed to assign new lady. Please try again.");
      } finally {
        setLoading(false);
      }
    } else {
      setError("Please select a lady ID.");
    }
  };

  const getLadyName = async (LadyID) => {
    const OnlyLadyID = LadyID?.replace("#FCW_", "");
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/${OnlyLadyID}`);
      return response.data.data.fname;
    } catch (error) {
      console.error("Error retrieving lady data:", error);
      return null;
    }
  };

  const handleNotifyClick = (VideoChatListData) => {
    let UserId = VideoChatListData.userId;
    let VideoID = VideoChatListData.svcId;
    let NameOfCallRequester = VideoChatListData.SvConsultation.fname + " " + VideoChatListData.SvConsultation.lname;

    if (UserId) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/users/${UserId}`)
        .then(async (response) => {
          const email = response.data.data.email;
          const ladyName = await getLadyName(VideoChatListData.SvConsultation.profilenumber_ladies);
          const mailsubject = `Reminder to Join Video Call on ${VideoChatListData.meetingDate},`;
          if (ladyName) {
            const MeetingInfo = `Dear ${NameOfCallRequester},<br/><br/>
            I hope this message finds you well.<br/><br/>
            I would like to confirm your scheduled video call with ${ladyName} on ${VideoChatListData.meetingDate}, at ${VideoChatListData.meetingTime}. The call is expected to last for ${VideoChatListData.meetingDuration} minutes.<br/><br/>
            Please join the meeting using the following link: <a href=${VideoChatListData.join_url}>Join Meeting</a>.<br/><br/>
            Thank you, and I look forward to your participation.`;
            sendMail(email, MeetingInfo, mailsubject);
          } else {
            console.error("Lady data not found");
            toast.error("Failed to retrieve lady name for notification.");
          }
        })
        .catch((error) => {
          console.error("Error retrieving user data:", error);
          toast.error("Failed to retrieve user data for notification.");
        });
    }
  };

  const sendMail = async (email, html, mailsubject) => {
    try {
      const mailData = {
        mailid: email,
        subject: mailsubject,
        html: html,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/svconsultation/sendCustomMail`,
        mailData,
        {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
          },
        }
      );
      setSuccessMessage("Email Sent successfully");
    } catch (error) {
      console.error("Error sending mail:", error);
      toast.error("Failed to send notification email.");
    }
  };

  const GetUsersSelectedLadyListing = async (SelectedCallID) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/svconsultation/get/${SelectedCallID}`,
        {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
          },
        }
      );
      const data = response.data.data.otherLadies;
      if (data && data.length !== 0) {
        if (typeof data === "string") {
          const ladiesArray = data.split(",").map((item, index) => {
            const idMatch = item.match(/#FCW_(\d+)/);
            const id = idMatch ? idMatch[1] : index;
            return { id };
          });
          setLadiesListingData(ladiesArray);
        }
      } else {
        setLadiesListingData([]);
      }
    } catch (error) {
      console.error("Error retrieving lady data:", error);
      toast.error("Failed to retrieve lady listing data.");
      return null;
    }
  };

  const handleAssignNewLady = (VideoChatListData) => {
    setSelectedId(VideoChatListData.meetingId);
    setSelectedName(VideoChatListData.svcId);
    GetUsersSelectedLadyListing(VideoChatListData?.SvConsultation?.id);
    setShowPopup(true);
  };

  // Handlers for View and Edit modals
  const handleViewProfile = (ladyId) => {
    console.log("View ladyId:", ladyId);
    if (!ladyId || ladyId === "N/A") {
      toast.error("Invalid lady ID.");
      return;
    }
    const numericId = ladyId.replace("#FCW_", "");
    if (!/^\d+$/.test(numericId)) {
      toast.error(`Invalid lady ID format: ${ladyId}`);
      return;
    }
    setSelectedLadyId(numericId);
    setShowViewModal(true);
  };

  const handleEditProfile = (ladyId) => {
    console.log("Edit ladyId:", ladyId);
    if (!ladyId || ladyId === "N/A") {
      toast.error("Invalid lady ID.");
      return;
    }
    const numericId = ladyId.replace("#FCW_", "");
    if (!/^\d+$/.test(numericId)) {
      toast.error(`Invalid lady ID format: ${ladyId}`);
      return;
    }
    setSelectedLadyId(numericId);
    setShowEditModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedLadyId(null);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedLadyId(null);
    fetchVideoChatFormData();
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <section className="page-info-sec">
        <div className="bg-fixed" style={{ backgroundImage: "url('./img/inner_banner.png')" }}></div>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col">
              <div className="page-info-block">
                <h1>All Requested Calls Listing</h1>
                <p className="page_nav">
                  <a href="/">Home</a>
                  <span className="mx-2">/</span>
                  <a href="#" className="currentPage">
                    All Requested Calls Listing
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="video-chat-form-sec secpd70">
        <div className="container myprofile_container">
          <div className="row">
            <div className="col-md-12">
              <div className="main-from-wrap">
                <div className="main-from-inner-wrap" style={main_from_inner_wrap_style}>
                  <div className="title-centered text-center">
                    <h2 className="title-30 mb-3">All Requested Calls Listing</h2>
                  </div>
                  {successMessage && (
                    <CustomAlert
                      message={successMessage}
                      type="success"
                      onClose={() => setSuccessMessage("")}
                    />
                  )}
                  {error && (
                    <CustomAlert
                      message={error}
                      type="error"
                      onClose={() => setError("")}
                    />
                  )}
                  <div className="formwrapperNew">
                    <div className="table-responsive">
                      <table className="table table-light table-striped">
                        <thead>
                          <tr className="text-center">
                            <th>Sno</th>
                            <th>Firstname</th>
                            <th>Lastname</th>
                            <th>Age</th>
                            <th>Occupation</th>
                            <th>Consultation Time</th>
                            <th>Call Type</th>
                            <th>Ladies Profile Id</th>
                            <th>Optional Ladies</th>
                            <th>Amount</th>
                            <th>Meeting Time</th>
                            <th>Meeting Date</th>
                            <th>Meeting Link</th>
                            <th>Assigned Translator</th>
                            <th>Meeting Status</th>
                            <th>Notify</th>
                            <th>Assign Lady</th>
                            <th>View</th>
                            <th>Edit</th>
                            {/* <th>Delete</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(FormList) && FormList.length > 0 ? (
                            FormList.map((VideoChatListData, key) => (
                              <tr key={key} className="text-center">
                                <td>{key + 1}</td>
                                <td>{VideoChatListData?.SvConsultation?.fname || "N/A"}</td>
                                <td>{VideoChatListData?.SvConsultation?.lname || "N/A"}</td>
                                <td>{VideoChatListData?.SvConsultation?.age || "N/A"}</td>
                                <td>{VideoChatListData?.SvConsultation?.occupation || "N/A"}</td>
                                <td>{VideoChatListData?.SvConsultation?.consultation_time || "N/A"}</td>
                                <td>{VideoChatListData?.type || "N/A"}</td>
                                <td>{VideoChatListData?.ladiesId || "N/A"}</td>
                                <td>{VideoChatListData?.otherLadies || "N/A"}</td>
                                <td>{VideoChatListData?.SvConsultation?.amount || "N/A"}</td>
                                <td>{VideoChatListData?.meetingTime || "N/A"}</td>
                                <td>{VideoChatListData?.meetingDate || "N/A"}</td>
                                <td>
                                  <a className="btn btn-warning" href={VideoChatListData?.join_url} target="_blank">
                                    Join
                                  </a>
                                </td>
                                <td>{VideoChatListData?.Translatordata?.fname || "N/A"}</td>
                                <td>{VideoChatListData?.status || "N/A"}</td>
                                <td>
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => handleNotifyClick(VideoChatListData)}
                                  >
                                    Notify
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => handleAssignNewLady(VideoChatListData)}
                                  >
                                    Assign New Lady
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-info btn-sm"
                                    onClick={() => handleViewProfile(VideoChatListData?.ladiesId)}
                                    disabled={!VideoChatListData?.ladiesId || VideoChatListData?.ladiesId === "N/A"}
                                  >
                                    View
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-warning btn-sm"
                                    onClick={() => handleEditProfile(VideoChatListData?.ladiesId)}
                                    disabled={!VideoChatListData?.ladiesId || VideoChatListData?.ladiesId === "N/A"}
                                  >
                                    Edit
                                  </button>
                                </td>
                                {/* <td>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => delUserdata(VideoChatListData?.svcId)}
                                  >
                                    Delete
                                  </button>
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" className="text-center">
                                No requested calls found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={Math.ceil(totalItems / itemsPerPage)}
                      handlePaginationClick={handlePaginationClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bootstrap Modal for Assign Lady */}
        {showPopup && (
          <div
            className={`modal fade ${showPopup ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: showPopup ? "rgba(0,0,0,0.5)" : "transparent" }}
          >
            <div className="modal-dialog modal-sm" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Assign Lady</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => togglePopup(null, "")}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleAssignladySubmit}>
                    <div className="mb-3">
                      <label htmlFor="lady_id" className="form-label">
                        Lady ID <span className="text-danger">*</span>
                      </label>
                      <select
                        name="lady_id"
                        id="lady_id"
                        className="form-select"
                        defaultValue=""
                        disabled={loading}
                        required
                      >
                        {ladieslisting.length === 0 ? (
                          <option value="">No other lady found</option>
                        ) : (
                          <>
                            <option value="">Select a lady to assign</option>
                            {ladieslisting.map((ladiesListData, key) =>
                              ladiesListData.role !== 2 ? (
                                <option key={key} value={ladiesListData.id}>
                                  #FCW_{ladiesListData.id}
                                </option>
                              ) : null
                            )}
                          </>
                        )}
                      </select>
                    </div>
                    <input type="hidden" name="caht_id" value={selectedName} />
                    <input type="hidden" name="meeting_id" value={selectedId} />
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      Assign
                    </button>
                  </form>
                  {error && (
                    <p className="text-danger mt-2">{error}</p>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => togglePopup(null, "")}
                    disabled={loading}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      <ViewUserModalProfile
        show={showViewModal}
        handleClose={handleCloseViewModal}
        userId={selectedLadyId}
        token={TOKEN}
      />
      <UpdateUserModalProfile
        show={showEditModal}
        handleClose={handleCloseEditModal}
        userId={selectedLadyId}
        token={TOKEN}
        fetchUsersData={fetchVideoChatFormData}
      />
    </>
  );
}

export default RequestedCallListing;